<template>
    <div class="page loginRegisterWrapper">
        <div class="image">
            <img src="@/assets/images/M3/logo-smis-gri.svg" alt="" class="login-mobile-logo">
            <LoginRegisterBG></LoginRegisterBG>
        </div>
        <b-overlay :show="loginLoading" class="date-user">
            <div>
                <LoginForm @loginStarted="loginLoading = true" @loginEnded="loginLoading = false"></LoginForm>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import LoginForm from "./componenets/LoginForm";
    import LoginRegisterBG from "./componenets/LoginRegisterBG";
    import {BOverlay} from 'bootstrap-vue';
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    export default {
        name: "Test",
        components: {
            LoginForm,
            LoginRegisterBG,
            BOverlay
        },
        props: {},
        data() {
            return {
                loginLoading: false
            };
        },
        created() {},
        mounted() {
            this.verificaMail();
        },
        methods: {
            verificaMail(){
                if(this.$route.name === "EmailVerify") {
                    axios.get(this.$route.fullPath)
                        .then(response=> {
                            this.$toast.success(response.data.message);
                            this.$route.params.emailVerificat =  true;
                            this.$router.push({ 
                                path: api.LOGIN_ROUTE , 
                                params:{ emailVerificat:true }, 
                                name:'Login'
                            });
                        }).catch(err => {
                            this.$toast.error(err.data ? err.data.message : '',{ duration:10000 });
                        })
                }
            }
        },
    };
</script>
<style scoped>
	.page {
		width: 100%;
		display: flex;
        background-color: #fff;
        height: auto;
	}
    .date-user{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

	.loginRegisterWrapper {
		position: relative;
	}
    @media (max-width:841px){
        body {
            height: max-content;
        }
        .page{
            flex-direction: column;
            height: max-content;
            min-height: 100vh;
        }
        .image{
            width: 100%;
        }
        .date-user{
            position: absolute;
            bottom: 0;
            background: transparent;
        }
    }
    @media (max-width:500px) {
        .page{
            display: block;
            min-height: auto;
            height: 100vh;
            
        }
        .date-user{
            width: 100%;
            padding: 0.4rem 0;
        }
    }
</style>
<style>
.loginRegisterWrapper .image {
    width: 75%;
    display: flex;
    flex-direction: column;
    align-self: center;
}
.loginRegisterWrapper .date-user {
    width: 35%;
    background-color: #fff;
    align-self: center;
}
.loginRegisterWrapper .login-mobile-logo {
    display: none;
}
@media (max-width: 1368px) {
    .loginRegisterWrapper .text-mare {
        margin-top: 1rem;
        font-size: 2rem;
    }
    .custom-control .custom-control-label {
        font-size: 11px;
    }
    .poza-login {
        max-height: 150px;
    }
}
@media (max-width: 1025px) {
    .loginRegisterWrapper .text-mare {
        margin-top: 10px;
        font-size: 1.875rem;
    }
    .loginRegisterWrapper .poza-login img {
        max-height: 26vh;
    }
    .loginRegisterWrapper .right-side {
        margin-top: 10px;
    }
    .loginRegisterWrapper .image {
        width: 65%;
    }
    .loginRegisterWrapper .date-user {
        width: 35%;
    }
}
@media (max-width: 841px) {
    .loginRegisterWrapper .date-user {
        width: 100%;
        background-color: transparent;
        padding: 0 10%;
    }
}
@media (max-width: 500px) {
    .loginRegisterWrapper .date-user {
        padding: 0;
    }
}
@media  (max-width:1440px) {
  .loginRegisterWrapper .bottom-text{
    position: relative;
    flex-direction: column;
    right: 0!important;
  }
  .loginRegisterWrapper .right-side {
    align-items: flex-start;
    margin-top: 20px;
  }
}

@media (max-width: 841px) {
  .loginRegisterWrapper {
    background-image: linear-gradient(to bottom right, #1f1f20, #5f656e);
    display: flex!important;
    justify-content: center;
  }
    .loginRegisterWrapper .image {
        margin-top: 50px;
    }
  .loginRegisterWrapper .image .background {
    display: none!important;
  }
  .loginRegisterWrapper .date-user {
    position: relative!important;
  }
  .loginRegisterWrapper .date-user label {
    font-size: 13px;
  }
  .loginRegisterWrapper .first-text {
    font-size: 17px!important;
  }
  .loginRegisterWrapper .second-text {
    font-size: 13px;
  }
  .loginRegisterWrapper .login-mobile-logo {
    height: 90px;
      margin-bottom: 20px;
    display: block;
  }
  .loginRegisterWrapper .custom-control-label {
    font-size: 10px!important;
    margin-bottom: 10px;
  }
}
</style>